<script setup lang="ts">
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { authApi } from '../api/auth' // 引入剛剛抽離的 API
import { useUserStore } from '@/stores/userStore'
import { useRoute } from 'vue-router'
import { canAccessResolvedRoute, getDefaultAuthorizedRoute } from '@/utils/accessNavigation'

const router = useRouter()
const route = useRoute()
const isLoggingIn = ref(false)
const loginData = reactive({ userId: '', password: '' })
const userStore = useUserStore()

const handleLogin = async () => {
  isLoggingIn.value = true
  try {
    const response = await authApi.login(loginData)

    if (response.ok) {
      const data = await response.json()
      userStore.setLoginInfo(data.token, data.user)

      const requestedPath = typeof route.query.redirect === 'string' ? route.query.redirect : ''
      const destination = requestedPath && canAccessResolvedRoute(router.resolve(requestedPath), data.user)
        ? requestedPath
        : getDefaultAuthorizedRoute(data.user)
      await router.replace(destination)
    } else {
      alert('❌ 登入失敗：帳號或密碼錯誤！')
    }
  } catch {
    alert('連線異常，請確認 API 是否已啟動')
  } finally {
    isLoggingIn.value = false
  }
}
</script>

<template>
  <div class="login-container">
    <div class="login-card">
      <h3 class="text-center mb-4 fw-bold" style="color: #9f4d95">合信進件管理系統</h3>
      <form @submit.prevent="handleLogin">
        <div class="mb-3">
          <label class="form-label fw-bold">帳號 (UserId)</label>
          <input
            type="text"
            class="form-control"
            v-model="loginData.userId"
            placeholder="請輸入帳號"
            required
          />
        </div>
        <div class="mb-4">
          <label class="form-label fw-bold">密碼 (Password)</label>
          <input
            type="password"
            class="form-control"
            v-model="loginData.password"
            placeholder="請輸入密碼"
            required
          />
        </div>
        <button
          type="submit"
          class="btn w-100 text-white fw-bold py-2"
          style="background-color: #9f4d95"
          :disabled="isLoggingIn"
        >
          {{ isLoggingIn ? '安全驗證中...' : '安全登入' }}
        </button>
      </form>
      <div class="text-center mt-3 text-muted" style="font-size: 0.8rem">
        測試帳密：aa001 / 12345
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-container {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  border: none;
  border-top: 5px solid #9f4d95;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #fff;
  padding: 30px;
  width: 100%;
  max-width: 400px;
}
</style>
